import React, { useState, useEffect } from 'react';
import { Clock, User, AlertCircle, CheckCircle, Calendar, Users } from 'lucide-react';
import { HitApi } from '../../../Api/ApiHit';
import { searchEvidence } from '../../../constant/Constant';
import { getElevateUser, getSelectedUnit } from '../../../storage/Storage';
import MongoosePagination from '../../../components/Pagination/MongoosePagination';
import { useDispatch, useSelector } from 'react-redux';
import { setPagination } from '../../../redux/Actions/TableAction';
import TaskCardIntervals from '../../../components/Cards/TaskCardIntervals';

function TodaysTask({ selectedUserId }) {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const TableDataReducer = useSelector((state) => state.TableReducer);
  const dispatch = useDispatch()

  // Use selectedUserId if provided (for admin view), otherwise use logged-in user
  const userId = selectedUserId || getElevateUser()?._id;

  useEffect(() => {
    getTodaysTask();
  }, [selectedUserId]);

  const getTodaysTask = () => {
    const today = new Date();
    const startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0).getTime();
    const endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59).getTime();

    var json = {
      page: TableDataReducer.pagination.page,
      limit: TableDataReducer.pagination.limit,
      search: {
        assignedTo: { $in: [userId] },
        unitIds: getSelectedUnit()?._id,
        createdAt: {
          $gte: startTime,
          $lte: endTime,
        },
      },
    };

    HitApi(json, searchEvidence).then((res) => {
      console.log("API Response:________", res);
      const paginationData = {
        total: res?.data?.totalDocs || 0,
        page: TableDataReducer.pagination.page,
        limit: TableDataReducer.pagination.limit,
      };

      dispatch(setPagination(paginationData))
      if (res.statusCode === 200 && res.data?.docs) {
        setTasks(res.data.docs || []);
      } else {
        setError('Failed to load tasks');
      }
      setLoading(false);
    }).catch((err) => {
      console.error("API Error:", err);
      setError('Error loading tasks');
      setLoading(false);
    });


  };



  const formatTime = (timestamp) => {
    return new Date(timestamp).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };



  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-3 text-gray-600">Loading today's tasks...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center">
          <AlertCircle className="w-5 h-5 text-red-400 mr-2" />
          <span className="text-red-800">{error}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white min-h-screen rounded-xl">
      <div className=" mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div className="text-sm text-gray-500">
            {new Date().toLocaleDateString('en-US', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </div>
        </div>
        {tasks.length === 0 ? (
          <div className="text-center py-12">
            <Calendar className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No tasks for today</h3>
            <p className="text-gray-500">You're all caught up! Check back later for new assignments.</p>
          </div>
        ) : (
          <div className="space-y-4">
            {tasks.map((task) => (
              <TaskCardIntervals key={task._id} task={task} getTodaysTask={getTodaysTask} />
            ))}
          </div>
        )}
      </div>
      <MongoosePagination />
    </div>
  );
}

export default TodaysTask;